export const DataTable = 'atlantis-data-table';